<template>
  <div class="wishlist" id="wishlist">
    <!-- 头部区域 -->
    <div class="header">
      <img
        class="header_bg"
        src="http://img.wish.hebyun.com.cn/images/interactWish_banner.png"
      />
      <!-- 参与人数 -->
      <div class="join">
        <div class="join_info">
          <span class="join_span">参与</span>
          <span class="join_nums">{{ join_user_count }}人</span>
        </div>
        <div class="join_avaters" v-if="avatar_list.length > 0">
          <img
            :src="avatar"
            v-for="(avatar, index) in avatar_list"
            :key="index"
          />
        </div>
        <div class="dots">...</div>
      </div>
      <!-- 心愿统计 -->
      <div class="wish_count">
        <img
          class="wish_count_bg"
          mode="widthFix"
          src="http://img.wish.hebyun.com.cn/images/interact_line.png"
        />
        <div class="wish_count_info">
          <span class="wish_count_span">提出心愿</span>
          <span class="wish_count_nums">{{ wish_count }}个</span>
        </div>
        <div class="wish_count_info">
          <span class="wish_count_span">完成心愿</span>
          <span class="wish_count_nums">{{ compeleted_wish_count }}个</span>
        </div>
      </div>
    </div>
    <!-- 内容区 -->
    <div class="contents">
      <!-- 选择区 -->
      <div class="choices">
        <div class="choice">
          <div class="choice_title">选择地区</div>
          <div class="choice_items">
            <van-tabs
              v-model="active"
              :ellipsis="false"
              title-active-color="#e50012"
              title-inactive-color="#999999"
              @click="onClickRegion"
            >
              <van-tab title="全部"></van-tab>
              <van-tab
                :title="reg.name"
                v-for="(reg, index) in region"
                :key="index"
              ></van-tab>
            </van-tabs>
          </div>
        </div>
        <div class="choice">
          <div class="choice_title">心愿方向</div>
          <div class="choice_items">
            <van-tabs
              v-model="wish_active"
              :ellipsis="false"
              title-active-color="#e50012"
              title-inactive-color="#999999"
              @click="onClickCategory"
            >
              <van-tab title="全部"></van-tab>
              <van-tab
                :title="cate.name"
                v-for="(cate, index) in category"
                :key="index"
              ></van-tab>
            </van-tabs>
          </div>
        </div>
      </div>
      <!-- 切换区 -->
      <div class="tabs">
        <!-- 切换头部 -->
        <div class="tab_headers">
          <div
            v-for="(item, index) in tabs"
            :key="index"
            class="tab_header"
            :class="tab === item ? 'active' : ''"
            @click="toggleTab(item)"
          >
            <span>{{ item }}</span>
          </div>
        </div>
        <van-pull-refresh v-model="isDownLoading" @refresh="onRefresh">
          <!-- 切换内容区 -->

          <div class="lists">
            <van-list
              v-model="vantList_IsLoading"
              :finished="vantList_IsLoadOver"
              offset="20"
              :finished-text="'我是有底线的'"
              :finish-text="'数据加载完毕'"
              :loading-text="'数据加载中...'"
              @load="onUpRefreshLoad"
            >
              <div class="list" v-for="(i, index) in datas" :key="index">
                <div class="list_avatar" @click="jumpDetail(i.wish.id)">
                  <img :src="i.user.avatar" />
                </div>
                <div class="list_contents">
                  <!-- 姓名区 -->
                  <div class="list_infos">
                    <div class="list_infos_left">
                      <div class="list_name_section">
                        <span
                          class="list_name"
                          @click="jumpDetail(i.wish.id)"
                          >{{ i.user.nick }}</span
                        >
                        <img
                          class="private_letter_btn"
                          @click="handleTap(i.user.id)"
                          src="http://img.wish.hebyun.com.cn/images/private_letter.png"
                        />
                      </div>
                      <div class="list_address">
                        {{ i.wish.city }}·{{ i.wish.area }}
                      </div>
                    </div>
                    <div class="list_infos_right">
                      <img
                        :src="
                          i.wish.is_top === 1
                            ? 'http://img.wish.hebyun.com.cn/images/hot.png'
                            : ''
                        "
                      />
                    </div>
                  </div>
                  <!-- 内容区 -->
                  <div class="list_des_section" @click="jumpDetail(i.wish.id)">
                    <div class="list_des">
                      {{ i.wish.content | ellipsis
                      }}<span
                        v-if="i.wish.content.length > 50"
                        style="color: #e50012; margin-left: 5px"
                        >展开</span
                      >
                    </div>
                  </div>

                  <div class="review_bottom" @click="jumpDetail(i.wish.id)">
                    <div
                      class="review_box"
                      v-for="(i, index) in i.img_list"
                      :key="index"
                    >
                      <img v-if="i.type === 1" :src="i.file_url" />
                      <video v-if="i.type === 2" :src="i.file_url"></video>
                    </div>
                  </div>
                  <!-- 心愿动态 -->
                  <div
                    class="wish_states"
                    @click="jumpDetail(i.wish.id)"
                    v-if="i.wish_dynamic != null"
                  >
                    <span class="wish_states_title">心愿动态：</span>
                    <span class="wish_states_info">{{ i.wish_dynamic }}</span>
                  </div>
                  <!-- 点赞评论关注区 -->
                  <div class="list_funs">
                    <div class="list_funs_time" @click="jumpDetail(i.wish.id)">
                      {{ i.wish.add_time }}
                    </div>
                    <div class="list_funs_right">
                      <!-- 点赞 👍 -->
                      <div class="thumb" @click="handleThumb(i.wish.id, index)">
                        <img
                          class="thumb_img"
                          :src="
                            i.is_thumb === 0
                              ? 'http://img.wish.hebyun.com.cn/images/thumb.png'
                              : 'http://img.wish.hebyun.com.cn/images/thumb_active.png'
                          "
                        />
                        <span
                          class="thumb_span"
                          :class="i.is_thumb === 0 ? '' : 'red'"
                          v-if="i.prize_count > 0"
                          >{{ i.prize_count }}</span
                        >
                      </div>
                      <div class="comment_btn" @click="jumpPldz(i.wish.id)">
                        <img
                          class="comment_img"
                          src="http://img.wish.hebyun.com.cn/images/comment.png"
                        />
                        <span class="comment_span" v-if="i.comment_count > 0">{{
                          i.comment_count
                        }}</span>
                      </div>
                      <div class="concern_btn" @click="jumpPldz(i.wish.id)">
                        <img
                          class="concern_img"
                          :src="
                            i.is_collect === 0
                              ? 'http://img.wish.hebyun.com.cn/images/concern_btn.png'
                              : 'http://img.wish.hebyun.com.cn/images/concern_btn_active.png'
                          "
                        />
                        <span
                          class="concern_span"
                          :class="i.is_collect === 0 ? '' : 'active'"
                          >{{ i.is_collect === 0 ? "关注" : "已关注" }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <!-- 评论区 -->
                  <div
                    class="list_comments"
                    @click="jumpDetail(i.wish.id)"
                    v-if="i.comment_count > 0"
                  >
                    <div
                      class="list_comment"
                      v-for="(comment, index) in i.comment_list"
                      :key="index"
                    >
                      <div class="list_comment_names">
                        <img
                          v-if="comment.user_type === 2"
                          :src="
                            comment.user_type === 2
                              ? 'http://img.wish.hebyun.com.cn/images/party.png'
                              : ''
                          "
                        />
                        <span>{{ comment.user_nick }}：</span>
                      </div>
                      <div class="list_comment_span">{{ comment.comment }}</div>
                    </div>
                    <div class="list_more">
                      共有{{ i.comment_count }}条评论>>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </div>
          <!-- 空状态 -->
          <van-empty
            image="http://img.wish.hebyun.com.cn/images/empty_state.png"
            description="暂无心愿"
            v-if="data_lengthShow == false"
          />
        </van-pull-refresh>
      </div>
    </div>
    <!-- 发布圆梦故事 -->
    <Button
      :button="button"
      @click.native="jumpRelease"
      v-if="userInfo.type != 3"
    />
    <div class="side_bars" v-if="isLogin()">
      <img
        src="http://img.wish.hebyun.com.cn/images/share_icon.png"
        @click="share"
      />
      <img
        src="http://img.wish.hebyun.com.cn/images/return_con.png"
        v-if="isFirstPage"
        @click="goback"
      />
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
// import SlideBar from "@/components/SlideBar";
let tabs = "已认领,待认领,已完成".split(",");
export default {
  name: "wish",
  components: {
    Button,
    // SlideBar,
  },
  data() {
    return {
      tabs,
      tab: tabs[0],
      show: false,
      message: "",
      active: 0,
      wish_active: 0,
      button: "我要发心愿",
      category: [], //心愿方向
      region: [], //地区
      categoryid: "",
      city: "",
      page: 0,
      limit: 5,
      datas: [], //心愿大厅数据
      url: "/wish/pager_for_index",
      url1: "/achieve/pager_list",
      state: 1, //待认领,已认领
      // 查询首页统计数字
      join_user_count: "",
      wish_count: "",
      compeleted_wish_count: "",
      avatar_list: [], //头像列表
      isDownLoading: false, // 下拉刷新
      vantList_IsLoading: false,
      vantList_IsLoadOver: false,
      data_lengthShow: true,
      isFirstPage: false,
      userInfo: {}, //用户信息
    };
  },
  created() {
    this.isFirstEnter = true;
    this.querySort();
    this.queryData();
    this.queryCount();
    if (this.isLogin()) {
      this.queryUserInfo();
    }

    let isFirstPage = localStorage.getItem("isFirstPage");
    if (isFirstPage == "0") {
      this.isFirstPage = true;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath.indexOf("wishDetail") !== -1) {
      //判断是从哪个路由过来的，若是detail页面不需要刷新获取新数据，直接用之前缓存的数据即可
      to.meta.isBack = true;
    } else if (from.fullPath.indexOf("fruit") !== -1) {
      to.meta.isBack = false;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack || this.isFirstEnter) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
      this.tab = this.tabs[0];
      this.datas = [];
      // 把数据清空，可以稍微避免让用户看到之前缓存的数据
      this.queryData();
    }
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false;
    // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
    this.isFirstEnter = false;
  },
  filters: {
    ellipsis(_val) {
      if (!_val) return "";
      if (_val.length > 50) {
        return _val.slice(0, 50) + "...";
      }
      return _val;
    },
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },

    //查询用户信息
    async queryUserInfo() {
      let { data } = await this.$api.queryUserInfo();
      this.userInfo = data;
    },
    share() {
      var url = window.location.href;

      var msg = {
        shareTitle: "我为群众办实事 党员帮办微心愿",
        shareSummary: "提交心愿、认领心愿、互动点赞，请登录“冀云”客户端",
        shareUrl: url,
        shareImage: "http://img.wish.hebyun.com.cn/images/wyxShare.jpg",
      };
      const u = navigator.userAgent,
        app = navigator.appVersion;
      console.log(app);

      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.webkit.messageHandlers.nativeShare.postMessage(
          JSON.stringify(msg)
        );
      } else {
        window.jsInterface.nativeShare(JSON.stringify(msg));
      }
    },
    // 跳转私信详情
    handleTap(id) {
      setTimeout(() => {
        this.$router.push({
          path: "/privateDetail",
          query: { id: id },
        });
      }, 250);
    },
    // 跳转详情
    jumpDetail(id) {
      this.$router.push({
        path: "/wishDetail",
        query: { id: id },
      });
    },
    // 评论判断
    jumpPldz(id) {
      if (this.isLogin()) {
        this.$router.push({
          path: "/wishDetail",
          query: { id: id },
        });
      } else {
          window.location.href =
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun";
      }
    },

    // 点击头部地区和方向
    onClickRegion(e) {
      if (e === 0) {
        this.city = "";
      } else {
        this.city = this.region[e - 1].name;
      }
      this.page = 1;
      this.datas = [];
      this.queryData();
    },
    onClickCategory(e) {
      if (e === 0) {
        this.categoryid = "";
      } else {
        this.categoryid = this.category[e - 1].id;
      }
      this.page = 1;
      this.queryData();
    },
    //心愿方向 地区
    async querySort() {
      let { data } = await this.$api.queryWishSort();
      this.region = data.region;
      this.category = data.category;
    },
    //分页查询心愿大厅的心愿
    async queryData() {
      this.vantList_IsLoading = true;
      let params = {
        page: this.page,
        limit: this.limit,
        state: this.state,
        categoryid: this.categoryid,
        city: this.city,
      };
      let { data } = await this.$api.queryWishList(params);
      data.forEach((item) => {
        item.is_thumb = 0;
      });

      if (this.page == 1) {
        this.datas = data;
      } else {
        this.datas = this.datas.concat(data);
      }
      this.vantList_IsLoading = false;
      if (data.length < this.limit) {
        this.vantList_IsLoadOver = true;
      } else {
        this.vantList_IsLoadOver = false;
        this.page = this.page + 1;
      }
    },

    // 切换头部tab
    toggleTab(e) {
      this.tab = e;
      if (e === "已认领") {
        this.state = 1;
        this.datas = [];
        this.page = 1;
        this.queryData();
      } else if (e === "待认领") {
        this.state = 0;
        this.datas = [];
        this.page = 1;
        this.queryData();
      } else if (e === "已完成") {
        this.$router.push("./fruit");
      }
    },
    //查询首页统计数字
    async queryCount() {
      let { data } = await this.$api.queryWishStatic();
      this.join_user_count = data.join_user_count;
      this.wish_count = data.wish_count;
      this.compeleted_wish_count = data.compeleted_wish_count;
      this.avatar_list = data.avatar_list;
    },
    // 我要发心愿
    jumpRelease() {
      this.checkIsLogin();
      if (this.isLogin()) {
        this.$router.push("/release");
      } else {
        window.location.href =
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun";
      }
    },
    // 点赞
    handleThumb(id, index) {
      this.checkIsLogin();
      if (this.datas[index].is_thumb == 0) {
        let data = {
          wishid: id,
        };
        this.$api.thumbWish(data);
        this.datas[index].is_thumb = 1;
        this.datas[index].prize_count += 1;
      } else {
        this.$api.error("请勿重复点赞");
      }
    },
    // 下拉加载
    onRefresh() {
      this.page = 1;
      this.queryData();
      this.$toast("刷新成功");
      this.isDownLoading = false;
    },
    // 上划分页
    onUpRefreshLoad() {
      this.queryData();
    },
  },
};
</script>

<style lang="scss">
.wishlist {
  padding-bottom: 10px;
  .lists .wish {
    margin: 0 auto 0;
  }
  .btn {
    position: fixed;
    bottom: 68px;
    width: 210px;
    height: 36px;
    bottom: 20px;
    span {
      font-size: 14px;
    }
  }
}
</style>
<style scoped lang="scss">
.wishlist {
  width: 100%;
  background-color: rgb(175, 31, 36);
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 头部区域 */
.header {
  position: relative;
  width: 100%;
  height: 169.5px;
  .header_bg {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    height: 169.5px;
  }
  /* 参与人数 */
  .join {
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding-top: 7px;

    .join_info {
      display: flex;
      align-items: center;
      .join_span {
        font-size: 12px;
        color: #ffef50;
      }

      .join_nums {
        font-size: 15px;
        color: #ffef50;
        font-weight: 800;
      }
    }

    .join_avaters {
      display: flex;
      align-items: center;
      margin-left: 7.5px;
      margin-right: 2px;
      img {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: solid 1px #fc703b;
        margin-left: -5px;
        vertical-align: middle;
        object-fit: cover;
      }
    }

    .dots {
      font-size: 12px;
      color: #fff656;
      font-weight: 600;
      margin-top: -5px;
    }
  }
  /* 心愿统计 */
  .wish_count {
    z-index: 1;
    position: absolute;
    bottom: 20px;
    left: calc((100% - 320px) / 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 320px;
    height: 30px;
    padding: 0 11px;
    box-sizing: border-box;
    .wish_count_bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 30px;
      z-index: -1;
    }
    .wish_count_info {
      display: flex;
      align-items: center;
      .wish_count_span {
        font-size: 12px;
        color: #333333;
      }

      .wish_count_nums {
        font-size: 15px;
        color: #e50012;
        font-weight: 800;
        padding-left: 7px;
      }
    }
  }
}

/* 内容区 */
.contents {
  width: 355px;
  background-color: #fff8d6;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  min-height: calc(100vh - 180px);
  padding-bottom: 100px;
  /* 选择区 */
  .choices {
    padding: 15px 10px 0;
    width: 100%;
    box-sizing: border-box;
    border-bottom: dashed 1px #e50012;
    .choice {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      overflow: hidden;
      flex-wrap: wrap;
      .choice_title {
        font-size: 15px;
        color: #333333;
        width: 70px;
      }
      .choice_items {
        width: calc(100% - 70px);
        /deep/.van-tabs__nav {
          background-color: transparent;
        }
        /deep/.van-tabs__line {
          background-color: transparent;
        }
        /deep/.van-tabs--line .van-tabs__wrap {
          height: auto;
        }
        /deep/.van-tabs__wrap--scrollable .van-tab {
          min-width: 60px;
          height: 25px;
          background-color: rgba(255, 255, 255, 0.8);
          border-radius: 24px;
          margin-right: 6px;
          font-size: 14px;
          line-height: normal;
        }
        /deep/.van-tabs__nav--line {
          padding-bottom: 0;
        }
        /deep/.van-tabs__nav--complete {
          padding-right: 0;
          padding-left: 0;
        }
      }
    }
  }
  .tabs {
    /* 切换头部 */
    .tab_headers {
      display: flex;
      align-items: center;
      height: 39px;
      line-height: 39px;
      .tab_header {
        position: relative;
        flex: 1;
        text-align: center;
        font-size: 18px;
        color: #333333;
      }
      .tab_header.active {
        color: #e50012;
        position: relative;
      }

      .tab_header.active::after {
        content: "";
        position: absolute;
        bottom: 3px;
        left: 50%;
        margin-left: -12.5px;
        width: 25px;
        height: 1px;
        background-color: #e60012;
      }
    }
    .tab_header::before {
      content: "";
      position: absolute;
      left: 0;
      top: 12.5px;
      width: 1px;
      height: 13px;
      background-color: #e60012;
    }
    .tab_header:first-child::before {
      background-color: transparent;
      width: 0;
    }
    /* 切换内容区 */
    .lists {
      margin-top: 0;
      .list {
        display: flex;
        justify-content: center;
        padding: 10px calc((100% - 345px) / 2);
        // width: 345px;
        // border-bottom:dashed 1px #e50012;
        box-sizing: border-box;
        .list_avatar {
          margin-right: 9.5px;
          width: 30.5px;
          height: 30.5px;
          img {
            width: 30.5px;
            height: 30.5px;
            border-radius: 50%;
            object-fit: cover;
          }
        }
        .list_contents {
          position: relative;
          width: 294px;
          .list_infos {
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            width: 100%;
            .list_infos_left {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              .list_name_section {
                display: inline-flex;
                align-items: center;
                margin-bottom: 5px;
                .list_name {
                  font-size: 18px;
                  color: #333333;
                }
                .private_letter_btn {
                  width: 15px;
                  height: 11px;
                  padding: 0 5px;
                }
              }
              .list_address {
                font-size: 12px;
                color: #666666;
                line-height: 1;
                padding-bottom: 10px;
                text-align: left;
              }
            }
            .list_infos_right {
              width: 13px;
              position: absolute;
              right: 0;
              top: 0;
              img {
                width: 13px;
                display: block;
              }
            }
          }
          /* 内容区 */
          .list_des_section {
            position: relative;
            margin-bottom: 10px;
            .list_des {
              font-size: 16px;
              line-height: 1.5;
              color: #333333;
              // max-height: 90px;
              // overflow: hidden;
              text-align: left;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }

            /* 图片区域 */
            .imgs {
              width: 100%;
              margin-top: 14.5px;
              img {
                width: 100%;
              }
            }
          }
          .review_bottom {
            // padding: 0 11px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 9.5px;
            box-sizing: border-box;
            img {
              width: 100%;
              border-radius: 10px;
              margin-right: 10px;
              object-fit: cover;
            }
            img:nth-child(3n) {
              margin-right: 0;
            }
          }
          /* 心愿动态 */
          .wish_states {
            display: flex;
            align-items: center;
            padding-top: 10px;
            padding-bottom: 10px;
            flex-wrap: wrap;
            .wish_states_title {
              font-size: 12px;
              color: #e50012;
            }
            .wish_states_info {
              font-size: 12px;
              color: #666666;
              text-align: left;
            }
          }

          /* 点赞评论关注区 */
          .list_funs {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
            padding-top: 10px;
            border-top: solid 1px rgba($color: #e50012, $alpha: 0.2);
            .list_funs_time {
              font-size: 12px;
              color: #999999;
            }
            .list_funs_right {
              display: flex;
              align-items: center;

              .thumb {
                display: flex;
                align-items: center;
                padding-right: 0px;
                .thumb_img {
                  width: 14px;
                  // vertical-align: middle;
                }

                .thumb_span {
                  font-size: 13px;
                  color: #999999;
                  margin-left: 2px;
                }
                .thumb_span.red {
                  color: #e50012;
                }
              }

              .comment_btn {
                position: relative;
                display: flex;
                align-items: center;
                padding: 0 5px 0 10px;
                margin-left: 8px;
                margin-top: 2px;
                .comment_img {
                  width: 14px;
                  height: 13px;
                  vertical-align: middle;
                }
                .comment_span {
                  font-size: 13px;
                  color: #999999;
                  margin-left: 2px;
                }
              }
              .comment_btn::before {
                position: absolute;
                content: "";
                width: 1px;
                height: 10px;
                background-color: #999;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
              }

              .concern_btn {
                display: flex;
                align-items: center;
                padding-left: 9px;
                position: relative;
                ::before {
                  position: absolute;
                  content: "";
                  width: 1px;
                  height: 10px;
                  background-color: #999;
                  left: 0;
                  top: 50%;
                  transform: translateY(-50%);
                }
                .concern_img {
                  width: 14px;
                  vertical-align: middle;
                }

                .concern_span {
                  font-size: 12px;
                  color: #999999;
                  margin-left: 2.5px;
                }
                .active {
                  color: #e50012;
                }
              }
            }
          }

          /* 评论区 */
          .list_comments {
            width: 294.5px;
            height: auto;
            background-color: #fff;
            border-radius: 10px;
            padding: 8px 15px 10px;
            margin: 0 0 10px 0;
            box-sizing: border-box;

            .list_comment {
              display: flex;
              align-items: center;
              margin-bottom: 5px;
              flex-wrap: wrap;
              font-size: 13px;
              .list_comment_names {
                display: inline-flex;
                align-items: center;
                margin-top: 4px;
                img {
                  width: 14.5px;
                  height: 14px;
                  margin-right: 4.5px;
                }
                span {
                  font-size: 13px;
                  font-weight: normal;
                  line-height: 1;
                  color: #e50012;
                }
              }
              .list_comment_span {
                font-size: 13px;
                line-height: 1;
                color: #666666;
                margin-top: 4px;
              }
            }
            .list_more {
              font-size: 13px;
              color: #e50012;
              text-align: left;
              margin-top: 4px;
            }
          }
        }
      }
      .list:not(:last-of-type) {
        //  border-bottom:1px dashed #e50012;
      }
    }
  }
}
</style>
